
import sidebars from '~/mixins/sidebars';

export default {
  mixins: [sidebars],
  props: [],
  data() {
    return {
      showSidebar: false,
      ticket: null,
      params: {
        unsichtbar: ['theta', 'tab', 'strike', 'code', 'paragraph', 'h1', 'h2', 'h3', 'code_block', 'hr', 'table', 'bilder']
      }
    }
  },
  methods: {
    open(params) {
      if (this.showSidebar) return;
      this.ticket = {
        titel: null,
        text: null,
        anliegen: false,
        bearbeiter: null,
      };
      if (params && params.ansprechpartner_id) {
        this.ticket.bearbeiter = [params.ansprechpartner_id];
      }
      this.openSidebar();
    },
    speichern() {
      this.$$store('app/tickets', this.ticket).then(response => {
        this.done();
        this.ticket = null;
      })
    },
    done() {
      let titel = "Dein Anliegen ist eingegangen.";
      let text = "Wir melden uns bei dir!";
      this.$router.push({path: '/intern/beendeter-vorgang', query: {titel: titel, text: text}})
    }
  },
  mounted() {
    this.$nuxt.$on('create-ticket', this.open);
  },
  beforeDestroy() {
    this.$nuxt.$off('create-ticket', this.open);
  },
}
